import React from "react";
import { useTranslation } from "react-i18next";

export function AdditionalDescriptionCombinations(props: {
	totalNumberOfCombinations: number;
}) {
	const { t } = useTranslation();

	const { totalNumberOfCombinations } = props;

	if (totalNumberOfCombinations <= 1) {
		return null;
	}

	return (
		<>
			{t<string>("ACC_STATEMENT.BET_DETAILS.INFO_COMBINATION_MULTI", {
				0: totalNumberOfCombinations,
			})}
		</>
	);
}
